import { CustomClaimValue, DeviceConfigCommand } from "@app/shared";
import { useHasClaim } from "../../../hooks";
import { CheckboxInput, InputRow } from "../inputs";
import { DeviceCommandEditorProps } from "./DeviceCommandEditor";

type EditDeviceConfigCommandProps = {} & DeviceCommandEditorProps;

/**
 * A device config command normally just tells the unit to re-pull its settings.
 *
 * The checkbox turns it into an override. A device that holds settings edits it has not managed to push
 * refuses to pull, on purpose — months of field edits must not lose to one stale dashboard change — but that
 * leaves a unit whose push can never succeed unable to be corrected from here, which is exactly the unit
 * someone needs to correct. Ticking this supersedes those unsent edits and takes the server's settings.
 *
 * Super admin only, and the same check is enforced in DeviceCommandController: hiding the checkbox is a
 * nicety, the endpoint takes whatever it is posted.
 */
export const EditDeviceConfigCommand: React.FC<EditDeviceConfigCommandProps> = (props) => {
    const isSuperAdmin = useHasClaim(CustomClaimValue.SuperAdmin);

    if (!isSuperAdmin)
        return <InputRow>No Parameters to Set</InputRow>;

    const command = props.command as DeviceConfigCommand;

    return (
        <InputRow>
            <CheckboxInput
                label="Force device to discard unsynced local settings edits"
                checked={!!command.forceOverwriteLocalEdits}
                onChange={(e) => props.onChange({ ...command, forceOverwriteLocalEdits: e.target.checked } as DeviceConfigCommand)}
            />
        </InputRow>
    );
}
